import { IDeleteBlocoUseCase } from "../../../presentation/useCases/delete/delete_bloco_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * deleteBlocoUseCaseUseCase
 */

export class DeleteBlocoUseCase implements IDeleteBlocoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) {

  }

  async deleteBloco(idBloco: number): Promise<void> {
    await this.repository.deleteBloco(idBloco);

  }

}
